import { Launch } from '@material-ui/icons';
import './Redirect-Url-Link.scss';

const RedirectUrlLink = (props) => {
  const { url } = props;
  return (
    <div className='d-inline-flex'>
      <div className='redirect-url'>
        <a href={url} className='url-link' target='_blank' rel='noopener noreferrer'>
          {url}
          <Launch fontSize='small' className='launch-icon' />
        </a>
      </div>
    </div>
  );
};

export default RedirectUrlLink;
